import React, {Component} from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";
import ShareButtonsBox from '../../../Shared/components/SocialMediaButtons/ShareButtonsBox'
import {PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN} from "../../../../App/RouterAdopta";
import TeamingButton from "../../../Shared/components/Contact/TeamingButton";
import Descripcion from "../../../Shared/components/components/Descripcion/Descripcion";
import CardImagesAnimalDetail from "../../../Animal/components/AnimalDetail/cards/CardImagesAnimalDetail";
import {Helmet} from "react-helmet";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../../analytics/config/analyticsParamsFrontEnd";
import ContactEntityComponent from "../../../Shared/components/Contact/ContactEntityComponent";
import NewSocialMedia from "../../../Shared/components/Contact/NewSocialMedia";
import {sendEvent} from "../../../../analytics/analitycs"
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";

class EntityProtectoraDetail extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            modeEmail_2: false,
            showModalContactByEmail: false
        }
        this.configContactComponent = {
            id: "",
            collSize: "divSelectContactoProtectora",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Alguna pregunta?"],
            messageWhatsapp: "Hola%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20vosotros%20",
            idSelect: "contactoProtectora",
            divSelect: '.divSelectContactoProtectora',
            tipo: 'EntityProtectora'
        };

        //Config información
        this.onClickSocialMediaFacebook = this.onClickSocialMediaFacebook.bind(this);
        this.onClickSocialMediaTwitter = this.onClickSocialMediaTwitter.bind(this);
        this.onClickSocialMediaInstagram = this.onClickSocialMediaInstagram.bind(this);
        this.configInformation = {
            titleHead: "Redes Sociales de <strong>" + this.props.infoEntity?.nombre + "</strong>",
            socials: [
                {
                    url: this.props.infoEntity?.facebook && this.props.infoEntity?.facebook?.url ? this.props.infoEntity?.facebook?.url : '',
                    socialIcon: "lab la-3x la-facebook",
                    onClick: this.onClickSocialMediaFacebook
                },
                {
                    url: this.props.infoEntity?.twitter && this.props.infoEntity?.twitter?.url ? this.props.infoEntity?.twitter?.url : '',
                    socialIcon: "lab la-3x la-twitter",
                    onClick: this.onClickSocialMediaTwitter
                },
                {
                    url: this.props.infoEntity?.instagram && this.props.infoEntity?.instagram?.url ? this.props.infoEntity?.instagram?.url : '',
                    socialIcon: "lab la-3x la-instagram",
                    onClick: this.onClickSocialMediaInstagram
                }
            ]
        };

        this.showImagenVideo = this.showImagenVideo.bind(this);
        this.onClickSocialMediaFacebook = this.onClickSocialMediaFacebook.bind(this);
        this.onClickSocialMediaTwitter = this.onClickSocialMediaTwitter.bind(this);
        this.onClickSocialMediaInstagram = this.onClickSocialMediaInstagram.bind(this);
        this.onClickSendEmail = this.onClickSendEmail.bind(this);
        this.onCloseModalContact = this.onCloseModalContact.bind(this);
        this.onClickShareButton = this.onClickShareButton.bind(this);
        this.onShowButtonTeaming = this.onShowButtonTeaming.bind(this);
        this.onClickButtonTeaming = this.onClickButtonTeaming.bind(this);
        this.hideDetail = this.hideDetail.bind(this);
        this.changeModeEmail = this.changeModeEmail.bind(this);
        this.hideEmailContact = this.hideEmailContact.bind(this);
        this.clickLinkDescripcion = this.clickLinkDescripcion.bind(this);
        this.clickLinkTeamingDescripcion = this.clickLinkTeamingDescripcion.bind(this);
        this.clickEmailDescripcion = this.clickEmailDescripcion.bind(this);
        this.renderHelmet = this.renderHelmet.bind(this);
        this.renderDescripcion = this.renderDescripcion.bind(this);
    }


    onClickSocialMediaFacebook() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.SOCIALMEDIA_FACEBOOK, {permalink: this.props.infoEntity?.permalink})
    }

    onClickSocialMediaTwitter() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.SOCIALMEDIA_TWITTER, {permalink: this.props.infoEntity?.permalink})
    }

    onClickSocialMediaInstagram() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.SOCIALMEDIA_INSTAGRAM, {permalink: this.props.infoEntity?.permalink})
    }

    showImagenVideo() {
        if (this.props.showProtectora) {
            $('#showImagesVideoProtectora').text("Ver fotos");
        } else {
            $('#showImagesVideoProtectora').text("Ocultar fotos");
        }
        this.props.showImagenVideoProtectora();
    }

    hideDetail() {
    }


    hideEmailContact() {
        //console.log("EntityProtectoraDetail::hideEmailContact()");
        this.changeModeEmail(false);
    }


    changeModeEmail(mode) {
        //console.log("EntityProtectoraDetail::changeModeEmail()");
        this.setState({modeEmail_2: mode})
    }

    onClickShareButton(socialMedia) {
        sendEvent(TIPOS_EVENTOS.SHARE, ELEMENTS.ENTITY.ENTITY, {
            permalink: this.props.infoEntity?.permalink,
            sharedOn: socialMedia
        })
    }

    capitalizeString(tkn) {
        if (tkn != undefined) {
            const REG_EXP_SEPARADORES = new RegExp(/[-.–\-,\/():“”"’'’#!?¿¡"@`^&]/, "gi")

            tkn = tkn.toLowerCase()
            let primeraLetra
            if (REG_EXP_SEPARADORES.test(tkn.slice(0, 1))) {
                primeraLetra = tkn.slice(0, 1) + tkn.slice(1, 2).toUpperCase()
                tkn = primeraLetra + tkn.slice(2, tkn.length)
            } else {
                primeraLetra = tkn.slice(0, 1).toUpperCase()
                tkn = primeraLetra + tkn.slice(1, tkn.length)
            }
        }

        return tkn;
    }


    clickLinkDescripcion() {
        //console.log("EntityProtectoraDetail::clickLinkDescripcion()");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.LINK_DESCRIPCION, {
            permalink: this.props.infoEntity?.permalink,
        });
    }

    clickLinkTeamingDescripcion() {
        //console.log("EntityProtectoraDetail::clickLinkTeamingDescripcion()");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.TEAMING_BUTTON, {
            permalink: this.props.infoEntity?.permalink,
        })
    }

    clickEmailDescripcion() {
        //console.log("EntityProtectoraDetail::clickEmailDescripcion()");


        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.EMAIL_DESCRIPCION, {
            permalink: this.props.infoEntity?.permalink,
        })
        // modeEmail(true, this.props.animalsControl);
        this.setState({
            showModalContactByEmail: true
        })
    }

    onCloseModalContact() {
        //console.log("EntityProtectoraDetail::onCloseModalContact()");
        this.setState({
            showModalContactByEmail: false
        })
    }

    onClickSendEmail() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.CONTACT_EMAIL, {
            permalink: this.props.infoEntity?.permalink
        })
    }

    onShowButtonTeaming() {
        sendEvent(TIPOS_EVENTOS.IMPRESION, ELEMENTS.ENTITY.TEAMING_BUTTON, {
            permalink: this.props.infoEntity?.permalink,
        })
    }

    onClickButtonTeaming() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.TEAMING_BUTTON, {
            permalink: this.props.infoEntity?.permalink,
        })
    }

    renderHelmet(infoEntity, subtitle_tipo) {
        return <Helmet>
            <title>{"🏡🐶 " + infoEntity.nombre + ", " + subtitle_tipo + " cerca de " + ((this.props.infoEntity?.direccion?.municipio) ? (this.props.infoEntity?.direccion?.municipio) : (infoEntity.direccion && this.props.infoEntity?.direccion?.region) ? (this.props.infoEntity?.direccion?.region) : this.props.infoEntity?.direccion?.provincia) + " en " + (this.props.infoEntity?.direccion?.provincia) + " | Adopta un Animal❕"}</title>
            <meta name="description"
                  content={infoEntity.nombre + ", como " + subtitle_tipo + " ofrece hogar temporal a perros y gatos sin hogar en busca de una familia. Adopción de perros y gatos en la zona de " + ((this.props.infoEntity?.direccion?.municipio) ? (this.props.infoEntity?.direccion?.municipio) : (infoEntity.direccion && this.props.infoEntity?.direccion?.region) ? (this.props.infoEntity?.direccion?.region) : this.props.infoEntity?.direccion?.provincia) + " en " + (this.props.infoEntity?.direccion?.provincia) + " y reducir el abandono de animales. " +
                      "Si quieres conocer más sobre " + infoEntity.nombre + " y cómo adoptar un perro o gato en su " + subtitle_tipo + " o cómo ayudar en su misión, ¡no dudes en ponerte en contacto con ellos!."}/>
            <meta property="og:title"
                  content={"🏡🐶 " + infoEntity.nombre + ", " + subtitle_tipo + " cerca de " + ((this.props.infoEntity?.direccion?.municipio) ? (this.props.infoEntity?.direccion?.municipio) : (infoEntity.direccion && this.props.infoEntity?.direccion?.region) ? (this.props.infoEntity?.direccion?.region) : this.props.infoEntity?.direccion?.provincia) + " en " + (this.props.infoEntity?.direccion?.provincia) + " | Adopta un Animal❕"}/>
            <meta property="og:description"
                  content={infoEntity.nombre + ", como " + subtitle_tipo + " ofrece hogar temporal a perros y gatos sin hogar en busca de una familia. Adopción de perros y gatos en la zona de " + ((this.props.infoEntity?.direccion?.municipio) ? (this.props.infoEntity?.direccion?.municipio) : (infoEntity.direccion && this.props.infoEntity?.direccion?.region) ? (this.props.infoEntity?.direccion?.region) : this.props.infoEntity?.direccion?.provincia) + " en " + (this.props.infoEntity?.direccion?.provincia) + " y reducir el abandono de animales. " +
                      "Si quieres conocer más sobre " + infoEntity.nombre + " y cómo adoptar un perro o gato en su " + subtitle_tipo + " o cómo ayudar en su misión, ¡no dudes en ponerte en contacto con ellos!."}/>
            <meta property="og:image"
                  content={(this.props.infoEntity?.img_principal?.share?.url) ? infoEntity.img_principal.share.url : this.props.infoEntity?.img_principal?.url}/>
            <meta property="og:image:type"
                  content={"image/" + ((this.props.infoEntity?.img_principal?.share?.url) ? infoEntity.img_principal.share.url?.split(".").pop() : this.props.infoEntity?.img_principal?.url?.split(".").pop())}/>
            <meta property="og:image:width" content="400"/>
            <meta property="og:image:height" content="300"/>
            <meta property="og:updated_time" content={infoEntity.timestamp_modificacion}/>
            <meta property="og:url"
                  content={this.props.HOST + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", infoEntity.tipo).replace(":permalink", infoEntity.permalink)}/>
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:site" content="@AdoptaunanimalE"/>
            <meta name="twitter:creator" content="@AdoptaunanimalE"/>
            <meta name="twitter:description"
                  content={infoEntity.nombre + ", como " + subtitle_tipo + " ofrece hogar temporal a perros y gatos sin hogar en busca de una familia. Adopción de perros y gatos en la zona de " + ((this.props.infoEntity?.direccion?.municipio) ? (this.props.infoEntity?.direccion?.municipio) : (infoEntity.direccion && this.props.infoEntity?.direccion?.region) ? (this.props.infoEntity?.direccion?.region) : this.props.infoEntity?.direccion?.provincia) + " en " + (this.props.infoEntity?.direccion?.provincia) + " y reducir el abandono de animales. " +
                      "Si quieres conocer más sobre " + infoEntity.nombre + " y cómo adoptar un perro o gato en su " + subtitle_tipo + " o cómo ayudar en su misión, ¡no dudes en ponerte en contacto con ellos!."}/>
            <link itemProp="thumbnailUrl"
                  href={(this.props.infoEntity?.img_principal?.share?.url) ? infoEntity.img_principal.share.url : this.props.infoEntity?.img_principal?.url}/>
        </Helmet>
    }

    renderDescripcion(infoEntity, subtitle_tipo, faqsFlags) {
        let especieManageStr = ""
        if (!faqsFlags || faqsFlags.perros || faqsFlags.perros === undefined) {
            especieManageStr += "perro";
        }
        if (!faqsFlags || ((faqsFlags.gatos || faqsFlags.gatos === undefined) && (faqsFlags.perros || faqsFlags.perros === undefined))) {
            especieManageStr += especieManageStr.length > 0 ? " o " : "";
        }
        if (!faqsFlags || faqsFlags.gatos || faqsFlags.gatos === undefined) {
            especieManageStr += "gato";
        }

        if (infoEntity.descripcion)
            return (
                <div>
                    <Descripcion
                        title={"Información de " + infoEntity.nombre}
                        nombre={infoEntity.nombre}
                        descripcion={infoEntity.descripcion?.replace(/\. /g, "\n")}
                        onClickLink={this.clickLinkDescripcion}
                        onClickLinkTeaming={this.clickLinkTeamingDescripcion}
                        onClickEmail={this.clickEmailDescripcion}
                        adsConfig={{
                            // adsTypes: [ADS_TYPES.ROBAPAGINAS,ADS_TYPES.SPLITSCREEN],
                            adsTypes: [ADS_TYPES.SPLITSCREEN, ADS_TYPES.ROBAPAGINAS],
                            insertAtEnd: true
                        }}
                    />
                    <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>

                    <div>
                        <div className="informationDetailDescriptionButtom">
                            <h2>¿Buscas adoptar un animal cerca
                                de {(infoEntity.direccion.municipio) ? (infoEntity.direccion.municipio) : (infoEntity.direccion && infoEntity.direccion.region) ? (infoEntity.direccion.region) : infoEntity.direccion.provincia}?</h2>
                            <div className="descripcion"><p>Como has
                                visto, <strong>{infoEntity.nombre}</strong> cuida y ofrece un hogar temporal
                                a {(!faqsFlags || faqsFlags?.perros || faqsFlags?.perros === undefined) ? "perros" : ""}{(!faqsFlags || ((faqsFlags?.gatos || faqsFlags?.gatos === undefined) && (faqsFlags?.perros || faqsFlags?.perros === undefined))) ? " y " : " "}{(!faqsFlags || faqsFlags?.gatos || faqsFlags?.gatos === undefined) ? "gatos" : ""} abandonados
                                sin hogar en busca de una familia adoptiva responsable en
                                su <strong> {subtitle_tipo}</strong>. Brindan cuidado y atención a todos los animales
                                acogidos y luchan con mucha dedicación y esfuerzo para fomentar la <strong>adopción de
                                    animales en la zona
                                    de {(infoEntity.direccion.municipio) ? (infoEntity.direccion.municipio) : (infoEntity.direccion && infoEntity.direccion.region) ? (infoEntity.direccion.region) : infoEntity.direccion.provincia} {(infoEntity.direccion.provincia !== infoEntity.direccion.municipio) ? "en " + infoEntity.direccion.provincia : ""} </strong> y
                                reducir el abandono de animales. </p> <p>Si quieres conocer más
                                sobre <strong>{infoEntity.nombre}</strong> y cómo <strong> adoptar
                                    un {especieManageStr}</strong> en
                                su {subtitle_tipo} de {(infoEntity.direccion.municipio) ? (infoEntity.direccion.municipio) : (infoEntity.direccion && infoEntity.direccion.region) ? (infoEntity.direccion.region) : infoEntity.direccion.provincia} o
                                cómo ayudar con su misión, ¡no dudes en ponerte en contacto con ellos!.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )

        else return (<div>
            <div className="informationDetailDescriptionButtom">
                <h2 className="card-title ">{"Información de " + infoEntity.nombre}</h2>
                <div className="descripcion">
                    <p><strong>¿Buscas adoptar un animal cerca
                        de {(infoEntity.direccion.municipio) ? (infoEntity.direccion.municipio) : (infoEntity.direccion && infoEntity.direccion.region) ? (infoEntity.direccion.region) : infoEntity.direccion.provincia}?</strong>
                    </p>
                    <p><strong>{infoEntity.nombre}</strong>, como <strong>{subtitle_tipo}</strong> ofrece
                        hogar temporal a perros y gatos sin hogar en busca de una familia adoptiva responsable. Brindan
                        cuidado y atención médica a todos los animales acogidos mientras trabajan en colaboración con
                        otros grupos de protección animal para fomentar de forma responsable la <strong>adopción de
                            animales en la zona
                            de {(infoEntity.direccion.municipio) ? (infoEntity.direccion.municipio) : (infoEntity.direccion && infoEntity.direccion.region) ? (infoEntity.direccion.region) : infoEntity.direccion.provincia} en {infoEntity.direccion.provincia}</strong> y
                        reducir el abandono de animales. </p>
                    <p>Si quieres conocer más sobre <strong>{infoEntity.nombre}</strong> y
                        cómo <strong> adoptar un {especieManageStr}</strong> en su {subtitle_tipo} o cómo ayudar en su
                        misión,
                        ¡no dudes en ponerte en contacto con ellos!.</p>
                </div>
            </div>
        </div>)
    }

    render() {
        const error = this.props.infoEntity.error;
        let showInfo;
        let direccion;

        Object.keys(this.props.infoEntity).length === 0 || error ? showInfo = false : showInfo = true;
        const tipo = this.props.infoEntity.tipo;
        let classSource = "";


        const direccionObj = this.props.infoEntity.direccion;
        if (direccionObj != null && (direccionObj.ocultar_direccion_exacta || direccionObj.ocultar_direccion_exacta === undefined)) {
            direccion = "Zona de " + direccionObj.municipio + ", " + direccionObj.provincia;
        } else if (direccionObj != null && !direccionObj.ocultar_direccion_exacta && direccionObj.calle && direccionObj.numero) {
            direccion = direccionObj.calle + ", " + direccionObj.numero + ", " + direccionObj.municipio + ", " + direccionObj.provincia
        } else if (direccionObj != null && direccionObj.municipio && direccionObj.provincia) {
            direccion = direccionObj.municipio + " (" + direccionObj.provincia + ")"
        } else {
            direccion = "Consultar dirección";
        }

        let nombre = this.props.infoEntity.nombre
        let subtipo = this.props.infoEntity.subtipo
        subtipo = this.capitalizeString(subtipo)

        let loc = (direccionObj && direccionObj.municipio) ? (direccionObj.municipio + ", " + direccionObj.provincia) : (direccionObj && direccionObj.region) ? (direccionObj.region + ", " + direccionObj.provincia) : direccionObj.provincia


        // let licenciaPPP = this.props.infoEntity.ppp

        // if (this.props.infoEntity && this.props.infoEntity.nombre) {
        //     nombreProtectora = this.props.infoEntity.nombre
        // }

        let srcImagen = this.props.infoEntity.img_principal && this.props.infoEntity.img_principal.url
            ? this.props.infoEntity.img_principal.url
            : `${process.env.CDN_URL}/images/adoptaunanimal/default/${this.props.infoEntity.tipo.toLowerCase()}2.png`
        // : getImageEncode("default." + tipo.toLowerCase())


        let galeria_imagenes = this.props.infoEntity.galeria_imagenes
        const teaming = this.props.infoEntity.teaming && this.props.infoEntity.teaming.url && this.props.infoEntity.teaming.nick ? this.props.infoEntity.teaming : undefined;

        let subtitle_tipo

        let tipoProtectoraTitle = "De la protectora "
        let tipoEntidad = this.props.infoEntity?.subtipo;
        if (tipoEntidad && ["Asociación", "Asociación CES"].includes(tipoEntidad)) {
            subtitle_tipo = "Asociación protectora de animales"
        } else if (tipoEntidad && ["Municipal"].includes(tipoEntidad)) {
            subtitle_tipo = "Protectora municipal de animales"
        } else if (tipoEntidad && ["Refugio", "Albergue"].includes(tipoEntidad)) {
            subtitle_tipo = tipoEntidad + " de animales"
        } else {
            subtitle_tipo = "Protectora de animales"
        }
        const faqsFlags = this.props.infoEntity.faqs

        return (
            <div key={"cardInfo-" + this.props.infoEntity._id} className="card animalDetail">
                {this.renderHelmet(this.props.infoEntity, subtitle_tipo)}
                <div className=" ">
                    {showInfo &&
                        <div className="newCardInfoDetailShow">
                            <div className="cardInfoTitle">

                                <h1>{nombre}</h1>
                                <h2 className="">
                                    <i className="las la-lg la-home"/>
                                    <span className="bold">{subtitle_tipo}</span> cerca
                                    de
                                    <span className="bold"> {loc}</span>
                                </h2>

                            </div>
                            <div className="informationDetailDescriptionUp">
                                <div className="informationDetailDescriptionLeft col-lg-4">

                                    <LazyLoadImage
                                        className="embed-responsive"
                                        src={srcImagen}
                                        threshold={150}
                                        // width={200}
                                        // height={280}
                                        alt={"Foto de " + {nombre} + " un " + subtipo + " en adopción cerca de " + {loc}}
                                    />
                                </div>
                                <div className="informationDetailDescriptionUpRight informationDetailProtectora">

                                    <div className="informationDetail informationDetailHeader ">
                                        <ul>
                                            <li>
                                                <span className="las la-3x la-home"/>
                                                <span
                                                    className="sexo"> {this.props.infoEntity?.tipo?.charAt(0)?.toUpperCase() + this.props.infoEntity?.tipo?.slice(1)} </span>
                                                <span className="sexo-data">{this.props.infoEntity.subtipo}</span>
                                            </li>
                                            <li>
                                                <span className="las la-3x la-map-marker"/>
                                                <span className="edad"> Municipio </span>
                                                <span
                                                    className="edad-data">{this.props.infoEntity?.direccion?.municipio}</span>
                                            </li>

                                            <li>
                                                <span className="las la-3x la-map"/>
                                                <span className="tamano"> Provincia </span>
                                                <span
                                                    className="tamano-data">{this.props.infoEntity?.direccion?.provincia}</span>
                                            </li>

                                        </ul>

                                    </div>
                                    <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS} onlyDesktop/>
                                    <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS} onlyMobile/>
                                    {teaming &&
                                        <div>
                                            <h5>Donaciones</h5>
                                            <TeamingButton
                                                id={this.props.infoEntity._id}
                                                nombre={this.props.infoEntity.nombre}
                                                teaming={teaming}
                                                onShowButton={this.onShowButtonTeaming}
                                                onClick={this.onClickButtonTeaming}
                                            />
                                        </div>
                                    }

                                </div>
                            </div>


                            <hr/>

                            <div className="sub-section">
                                {this.renderDescripcion(this.props.infoEntity, subtitle_tipo, faqsFlags)}
                            </div>

                            {galeria_imagenes && galeria_imagenes.length > 0 &&
                                <div className="sub-section">
                                    <hr/>

                                    <CardImagesAnimalDetail
                                        animalDetail={this.props.infoEntity}
                                        animalsControl={this.props.animalsControl}
                                        animalsControlDetail={this.props.animalsControlDetail}
                                        idAnimal={this.props.infoEntity._id}
                                        index={this.props.index}
                                    />
                                </div>
                            }
                            <hr/>
                            <div>
                                <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS}/>
                                <hr/>
                                <div className="social-media-block">
                                    <NewSocialMedia
                                        bottom={true}
                                        configInformation={this.configInformation}
                                    />
                                </div>
                                {/*<div className="contacto-block">*/}
                                {/*    <NewV2ContactComponent*/}
                                {/*        infoProtectoraDetail={this.props.infoEntity}*/}
                                {/*        tipoContacto={"Entity_protectora"}*/}
                                {/*        urlWhastapp={process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", this.props.infoEntity?.tipo).replace(":permalink", this.props.infoEntity?.permalink)}*/}
                                {/*        configEstadoContacto={this.configContactComponent}*/}
                                {/*        // animalsControl={this.props.animalsControl}*/}
                                {/*        // animalsControlDetail={this.props.animalsControlDetail}*/}
                                {/*        changeModeEmail={this.changeModeEmail}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div className=" text-left">
                                    <div className="moreProtectoraInfo">
                                        <h4>Compartir <strong>{this.props.infoEntity.nombre}</strong> en redes
                                            sociales</h4>
                                        <ShareButtonsBox
                                            shareURL={process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", this.props.infoEntity?.tipo).replace(":permalink", this.props.infoEntity?.permalink)}
                                            permalink={PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", this.props.infoEntity?.tipo).replace(":permalink", this.props.infoEntity?.permalink)}
                                            text={""}
                                            hashtags={["AdoptaNoCompres"]}
                                            onClickShareButton={this.onClickShareButton}
                                            stickyMode
                                            normalMode
                                        />
                                    </div>
                                </div>
                            </div>
                            {/*<div className="informationDetailProtectora__row-100">*/}
                            {/*    <div className="div-rrss-contacto-protectora">*/}
                            {/*        <NewV2ContactComponent*/}
                            {/*            infoEntity={this.props.infoEntity}*/}
                            {/*            tipoContacto={"animal"}*/}
                            {/*            */}
                            {/*            urlWhastapp={process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PATTERN.replace(":tipo_entity", "protectora") + this.props.infoEntity?._id}*/}
                            {/*            configEstadoContacto={this.configEstadoContacto}*/}
                            {/*            animalsControl={this.props.animalsControl}*/}
                            {/*            animalsControlDetail={this.props.animalsControlDetail}*/}
                            {/*            changeModeEmail={this.changeModeEmail}*/}
                            {/*        />*/}
                            {/*    </div>*/}
                            <hr/>
                            <AdsManagerContainer type={ADS_TYPES.SPLITSCREEN}/>

                            <hr/>
                            <div className="contacto-block">
                                <ContactEntityComponent
                                    entity={this.props.infoEntity}
                                    tipoContacto={"EntityProtectora"}
                                    urlWhastapp={process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", this.props.infoEntity?.tipo).replace(":permalink", this.props.infoEntity?.permalink)}
                                    configEstadoContacto={this.configContactComponent}
                                    // animalsControl={this.props.animalsControl}
                                    // animalsControlDetail={this.props.animalsControlDetail}
                                    changeModeEmail={this.changeModeEmail}
                                    showModalContactByEmail={this.state.showModalContactByEmail}
                                    onCloseModal={this.onCloseModalContact}
                                    onClickSendEmail={this.onClickSendEmail}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        );

    }

    componentWillMount() {

    }

    componentDidMount() {


    }

    componentDidUpdate() {

    }


}

export default EntityProtectoraDetail
